import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToastService } from '@vsolv/vectors-ui/alert';
import { DialogComponent } from '@vsolv/vectors-ui/dialog';

interface Element {
  id: string;
  title: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-delete-element-dialog',
  templateUrl: './delete-element.dialog.html',
  standalone: false,
})
export class DeleteElementDialog {
  constructor(
    private toastSvc: ToastService,
    private http: HttpClient
  ) {}

  @ViewChild(DialogComponent) dialog!: DialogComponent;

  @Input() element?: Element | null = null;

  @Output() closed = new EventEmitter<boolean>();

  deleting = false;
  hasChildren = false;

  open(element: Element, hasChildren = false) {
    this.element = element;
    this.hasChildren = hasChildren;
    this.dialog.open();
  }

  close(fromClose?: boolean) {
    this.deleting = false;
    this.hasChildren = false;

    if (!fromClose) this.dialog.close();
  }

  cancel() {
    this.close();
    this.closed.emit(false);
  }

  delete() {
    if (!this.element) return;

    this.deleting = true;

    const title = this.element.title;

    this.http.delete(`/v1/rating/elements/${this.element.id}`).subscribe({
      next: () => {
        this.toastSvc.show({
          type: 'success',
          title: 'Element deleted',
          text: `<strong>${title}</strong> has been successfully deleted.`,
        });
        this.close();
        this.closed.emit(true);
      },
      error: (error: { error?: { message?: string } }) => {
        this.toastSvc.show({
          type: 'error',
          title: 'Something went wrong',
          text: error?.error?.message || 'Unable to delete element.',
        });
        this.deleting = false;
      },
    });
  }
}
